import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { InheritedThemeProvider } from "@convertkit/editor"

export function Quote({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    borderTopLeftRadius: `${properties.borderTopLeftRadius}px`,
    borderTopRightRadius: `${properties.borderTopRightRadius}px`,
    borderBottomLeftRadius: `${properties.borderBottomLeftRadius}px`,
    borderBottomRightRadius: `${properties.borderBottomRightRadius}px`,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    paddingTop: `${properties.paddingTop}px`,
    paddingRight: `${properties.paddingRight}px`,
    paddingBottom: `${properties.paddingBottom}px`,
    paddingLeft: `${properties.paddingLeft}px`,
    fontFamily: properties.textFontFamily,
    fontSize: `${properties.textFontSize}px`,
    lineHeight: properties.textLineHeight,
    borderStyle: "solid",
    overflow: "hidden"
  }

  return (
    <div className="ck-quote ck-layout-block-template">
      <div style={containerStyle}>
        <InheritedThemeProvider
          theme={{
            paragraph: {
              color: properties.nameColor,
              fontFamily: properties.textFontFamily,
              fontSize: properties.textFontSize,
              fontWeight: 700
            }
          }}
        >
          <LiteSlateEditor block_id={children[0].block_id} />
        </InheritedThemeProvider>
      </div>
      <div
        style={{
          width: 0,
          height: 0,
          borderLeft: "20px solid transparent",
          borderRight: "20px solid transparent",
          borderTop: `20px solid ${properties.borderColor}`,
          margin: "0 auto"
        }}
      >
        &nbsp;
      </div>
      <InheritedThemeProvider
        theme={{
          paragraph: {
            color: properties.nameColor,
            fontFamily: properties.nameFontFamily,
            fontSize: properties.nameFontSize,
            textAlign: "center",
            lineHeight: properties.nameLineHeight
          }
        }}
      >
        <LiteSlateEditor block_id={children[1].block_id} />
      </InheritedThemeProvider>
    </div>
  )
}
